import {TuiRoot} from "@taiga-ui/core";
import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {DashboardComponent} from '../dashboard/component';
import {Actions, ofActionCompleted, Store} from '@ngxs/store';
import {RouterNavigated, RouterNavigation} from '@ngxs/router-plugin';
import {map, merge} from "rxjs";
import {toSignal} from '@angular/core/rxjs-interop';
import {TuiProgress} from '@taiga-ui/kit';
import {NgClass} from '@angular/common';
import {SearchState} from '../core/+state/search/state';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot, DashboardComponent, TuiProgress, NgClass],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly actions = inject(Actions);
  private readonly store = inject(Store);
  private readonly searchLoadingState = this.store.select(SearchState.getLoadingState);

  private readonly routeStart = this.actions.pipe(
    ofActionCompleted(RouterNavigation),
    map(() => true)
  );
  private readonly routeEnd = this.actions.pipe(
    ofActionCompleted(RouterNavigated),
    map(() => false)
  );

  showRouterProgress = toSignal(
    merge(this.routeStart, this.routeEnd, this.searchLoadingState),
    {
      initialValue: false,
    }
  );
}
